<template>
    <div>
        <Header />
        <div class="desktop">
            <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
        </div>
        <div class="mobile">
            <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText"
                :isTextinput="false" />
        </div>
        <BodyLinks />
        <b-container class=" mt-4">
            <Activation />
            <div class="desktop">
                <b-row class="">
                    <b-col cols="3">
                        <ListingSidebar create='active' />
                    </b-col>
                    <b-col cols="9">
                        <b-row class="head-box text-center">
                            <b-col cols="6" v-scroll-to="'#listing-details'" v-bind:class="{ 'active' : isSelected(0) }"
                                v-on:click="selected = 0" class="inner-header-box">
                                <b-icon icon="shop"></b-icon> Listing Details
                            </b-col>
                            <b-col cols="6" v-scroll-to="'#guest-pref'" v-bind:class="{ 'active' : isSelected(1) }"
                                v-on:click="selected = 1" class="inner-header-box">
                                <b-icon icon="hand-thumbs-up"></b-icon> Guest Preference
                            </b-col>
                        </b-row>

                        <div class="shadow-container">
                            <p id="listing-details">Listing Details </p>
                            <form @submit.prevent="updateListing" action="">
                                <b-row class="mt-4">
                                    <b-form-group class="col-md-6 mb-4" label-for="input-1">
                                        <b-input-group class="">
                                            <b-input-group-prepend is-text>
                                                <b-icon icon="tag"></b-icon>
                                            </b-input-group-prepend>
                                            <b-form-input type="text" required v-model="listing.name"
                                                placeholder="Title"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                    <b-form-group class="col-md-6 mb-4" label-for="region">
                                        <b-form-select v-model="listing.region" required :options="regions">
                                        </b-form-select>
                                    </b-form-group>
                                    <b-form-group class="col-md-6 mb-4" label-for="attendance_mode">
                                        <b-form-select v-model="listing.attendance_mode" required
                                            :options="attendances"></b-form-select>
                                    </b-form-group>
                                    <b-form-group class="col-md-6 mb-4" label-for="address"
                                        v-if="listing.attendance_mode == 'online'">
                                        <b-input-group class="">
                                            <b-input-group-prepend is-text>
                                                <b-icon icon="geo"></b-icon>
                                            </b-input-group-prepend>
                                            <b-form-input type="text" v-model="listing.address"
                                                placeholder="Online Link"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                    <b-form-group class="col-md-6 mb-4" label-for="address"
                                        v-if="listing.attendance_mode == 'physical'">
                                        <b-input-group class="">
                                            <b-input-group-prepend is-text>
                                                <b-icon icon="globe"></b-icon>
                                            </b-input-group-prepend>
                                            <vue-google-autocomplete v-model="listing.address" id="cl-map" ref="address"
                                                classname="form-control" placeholder="Enter an address or location"
                                                v-on:placechanged="getAddressData">
                                            </vue-google-autocomplete>
                                        </b-input-group>
                                    </b-form-group>
                                    <b-form-group class="col-md-6 mb-4" label-for="category">
                                        <select required class="mb-3 custom-select" v-model="listing.event_type_id"
                                            @change="categoryChange">
                                            <option value="null" selected disabled>Please select Category</option>
                                            <option v-for="(category, index) in categories"
                                                :selected="selectedOption(category)" :key="index" :value="category.id">
                                                {{ category.name }}
                                            </option>
                                        </select>
                                    </b-form-group>
                                    <b-form-group class="col-md-6 mb-4" label-for="subcategory">
                                        <select class="mb-3 custom-select" v-model="listing.event_sub_type_id">
                                            <option value="null" selected disabled>Please select sub category</option>
                                            <option v-for="(category, index) in subCategories" :key="index"
                                                :value="category.id">
                                                {{ category.name }}
                                            </option>
                                        </select>
                                    </b-form-group>

                                    <b-form-group class="col-md-6 mb-4" label-for="fee_status">
                                        <b-form-select v-model="listing.fee_status" required :options="fees">
                                        </b-form-select>
                                    </b-form-group>
                                    <b-form-group class="col-md-6 mb-4" label-for="currency"
                                        v-if="listing.fee_status ==='Paid'">
                                        <b-form-select required v-model="listing.currency" :options="currencies">
                                        </b-form-select>
                                    </b-form-group>
                                    <b-form-group class="col-md-6 mb-4" label-for="amount"
                                        v-if="listing.fee_status ==='Paid'">
                                        <b-input-group class="">
                                            <b-form-input required type="number" min="0" v-model="listing.amount"
                                                placeholder="Price Per member"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>

                                    <b-form-group class="col-md-12 mb-3" label-for="fee_status">
                                        <vue-editor :editor-toolbar="customToolbar" placeholder="Event Description"
                                            v-model="listing.description" />
                                    </b-form-group>

                                    <b-form-group class="col-md-6 mb-4" label-for="start_day">
                                        <date-picker required v-model="listing.start_day" valueType="format"
                                            format="YYYY-MM-DD" placeholder="Start Date" id="startDay" type="date">
                                        </date-picker>
                                    </b-form-group>
                                    <b-form-group class="col-md-6 mb-4" label-for="end_day">
                                        <date-picker required v-model="listing.end_day" valueType="format"
                                            format="YYYY-MM-DD" placeholder="End Date" id="endDay" type="date">
                                        </date-picker>
                                    </b-form-group>
                                    <b-form-group class="col-md-6 mb-4" label-for="start_time">
                                        <b-form-timepicker required no-flip v-model="listing.start_time" now-button
                                            reset-button locale="en"></b-form-timepicker>
                                    </b-form-group>
                                    <b-form-group class="col-md-6 mb-4" label-for="end_time">
                                        <b-form-timepicker required no-flip v-model="listing.end_time" now-button
                                            reset-button locale="en"></b-form-timepicker>
                                    </b-form-group>
                                    <div class="col-md-12">
                                        <div class="file-container mb-4">
                                            <p>Upload listing Image</p>
                                            <div @click="openFile" class="btn btn-warning">Choose File
                                                <b-icon scale="0.8" icon="cloud-arrow-up"></b-icon>
                                            </div>
                                            <b-form-file @change="showFileName" style="visibility:hidden" id="fileImage"
                                                class="mt-3" plain></b-form-file><span>{{filename}}</span>
                                        </div>
                                    </div>
                                </b-row>
                                <p id="guest-pref" class="mb-4 mt-4">Guest Preference</p>
                                <b-row class="mt-4">
                                    <b-form-group class="col-md-6 mb-4" label-for="age_limit">
                                        <b-input-group class="">
                                            <b-form-input type="number" min="1" v-model="listing.age_limit"
                                                placeholder="Age Limit (not under)"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                    <b-form-group class="col-md-6 mb-4" label-for="age_limit">
                                        <b-input-group class="">
                                            <b-form-input type="text" v-model="listing.item_contributions"
                                                placeholder="Item contributions"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                    <b-form-group class="col-md-6 mb-4" label-for="guest_limit">
                                        <b-input-group class="">
                                            <b-form-input type="number" required min="0" v-model="listing.guest_limit"
                                                placeholder="Guest Limit (No. of total guests)"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                    <b-form-group class="col-md-6 mb-4" label-for="guest_gender">
                                        <b-form-select required v-model="listing.guest_gender" :options="genders">
                                        </b-form-select>
                                    </b-form-group>
                                    <b-form-group class="col-md-6 mb-4" label-for="input-1">
                                        <b-form-select required v-model="listing.guest_category" :options="statuses">
                                        </b-form-select>
                                    </b-form-group>
                                    <b-form-group class="col-md-6 mb-4" label-for="guest_nationality_id">
                                        <select required class="mb-3 custom-select"
                                            v-model="listing.guest_nationality_id">
                                            <option value="" selected disabled>Please select nationality</option>
                                            <option v-for="(country, index) in countries" :key="index"
                                                :value="country.country_id">
                                                {{ country.name }}
                                            </option>
                                        </select>
                                    </b-form-group>

                                </b-row>

                                <b-row class="mt-4">
                                    <b-form-group class=" col-md-12 mb-3" label-for="input-1">
                                        <button class="float-right btn btn-warning">{{btnText}}
                                            <font-awesome-icon :icon="['fas', 'arrow-right']" />
                                        </button>
                                    </b-form-group>

                                </b-row>
                            </form>
                        </div>

                    </b-col>
                </b-row>
            </div>
            <div class="mobile">
                <b-row class="">
                    <b-col cols="3">
                        <b-icon @click="openMenu" icon="list" scale="2"></b-icon>
                        <div class="slide-menu card sidecard" id="slidmenu" v-click-outside="hideSidemenu">
                            <ListingSidebar create='active' />
                        </div>
                    </b-col>
                    <b-col cols="9">
                        <b-row class="head-box text-center">
                            <b-col cols="12" v-scroll-to="'#listing-details'"
                                v-bind:class="{ 'active' : isSelected(0) }" v-on:click="selected = 0"
                                class="inner-header-box">
                                <b-icon icon="shop"></b-icon> Listing Details
                            </b-col>
                            <b-col cols="12" v-scroll-to="'#guest-pref'" v-bind:class="{ 'active' : isSelected(1) }"
                                v-on:click="selected = 1" class="inner-header-box">
                                <b-icon icon="hand-thumbs-up"></b-icon> Guest Preference
                            </b-col>
                            <b-col cols="12" v-scroll-to="'#finish-up'" v-bind:class="{ 'active' : isSelected(3) }"
                                v-on:click="selected = 3" class="inner-header-box">
                                <b-icon icon="heart"></b-icon> Finish up
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols=12>
                        <div class="shadow-container">
                            <p id="listing-details">Listing Details </p>
                            <b-row class="mt-4">
                                <b-form-group class="col-md-6 mb-4" label-for="input-1">
                                    <b-input-group class="">
                                        <b-input-group-prepend is-text>
                                            <b-icon icon="tag"></b-icon>
                                        </b-input-group-prepend>
                                        <b-form-input type="text" required v-model="listing.name" placeholder="Title">
                                        </b-form-input>
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group class="col-md-6 mb-4" label-for="attendance_mode">
                                    <b-form-select v-model="listing.attendance_mode" required :options="attendances">
                                    </b-form-select>
                                </b-form-group>
                                <b-form-group class="col-md-6 mb-4" label-for="address"
                                    v-if="listing.attendance_mode == 'online'">
                                    <b-input-group class="">
                                        <b-input-group-prepend is-text>
                                            <b-icon icon="geo"></b-icon>
                                        </b-input-group-prepend>
                                        <b-form-input type="text" v-model="listing.address" placeholder="Online Link">
                                        </b-form-input>
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group class="col-md-6 mb-4" label-for="address"
                                    v-if="listing.attendance_mode == 'physical'">
                                    <b-input-group class="">
                                        <b-input-group-prepend is-text>
                                            <b-icon icon="globe"></b-icon>
                                        </b-input-group-prepend>
                                        <vue-google-autocomplete v-model="listing.address" id="cl-map" ref="address"
                                            classname="form-control" placeholder="Enter an address or location"
                                            v-on:placechanged="getAddressData">
                                        </vue-google-autocomplete>
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group class="col-md-6 mb-4" label-for="category">
                                    <select required class="mb-3 custom-select" v-model="listing.event_type_id"
                                        @change="categoryChange">
                                        <option value="null" selected disabled>Please select Category</option>
                                        <option v-for="(category, index) in categories"
                                            :selected="selectedOption(category)" :key="index" :value="category.id">
                                            {{ category.name }}
                                        </option>
                                    </select>
                                </b-form-group>
                                <b-form-group class="col-md-6 mb-4" label-for="subcategory">
                                    <select class="mb-3 custom-select" v-model="listing.event_sub_type_id">
                                        <option value="null" selected disabled>Please select sub category</option>
                                        <option v-for="(category, index) in subCategories" :key="index"
                                            :value="category.id">
                                            {{ category.name }}
                                        </option>
                                    </select>
                                </b-form-group>
                                <b-form-group class="col-md-12 mb-3" label-for="fee_status">
                                    <vue-editor :editor-toolbar="customToolbar" placeholder="Event Description"
                                        v-model="listing.description" />
                                </b-form-group>

                                <div class="col-md-6">
                                    <b-form-group class=" mb-4" label-for="fee_status">
                                        <b-form-select v-model="listing.fee_status" required :options="fees">
                                        </b-form-select>
                                    </b-form-group>
                                    <b-form-group class=" mb-4" label-for="currency"
                                        v-if="listing.fee_status ==='Paid'">
                                        <b-form-select required v-model="listing.currency" :options="currencies">
                                        </b-form-select>
                                    </b-form-group>
                                    <b-form-group class=" mb-4" label-for="amount" v-if="listing.fee_status ==='Paid'">
                                        <b-input-group class="">
                                            <b-form-input required type="number" step=".01" min="0"
                                                v-model="listing.amount" placeholder="Price Per member"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <b-form-group class="col-md-6 mb-4" label-for="start_day">
                                    <date-picker required v-model="listing.start_day" valueType="format"
                                        format="YYYY-MM-DD" placeholder="Start Date" id="startDay" type="date">
                                    </date-picker>
                                </b-form-group>
                                <b-form-group class="col-md-6 mb-4" label-for="end_day">
                                    <date-picker required v-model="listing.end_day" valueType="format"
                                        format="YYYY-MM-DD" placeholder="End Date" id="endDay" type="date">
                                    </date-picker>
                                </b-form-group>
                                <b-form-group class="col-md-6 mb-4" label-for="start_time">
                                    <b-form-timepicker required no-flip v-model="listing.start_time" now-button
                                        reset-button locale="en"></b-form-timepicker>
                                </b-form-group>
                                <b-form-group class="col-md-6 mb-4" label-for="end_time">
                                    <b-form-timepicker required no-flip v-model="listing.end_time" now-button
                                        reset-button locale="en"></b-form-timepicker>
                                </b-form-group>
                                <div class="col-md-12">
                                    <div class="file-container mb-4">
                                        <p>Upload listing Image</p>
                                        <div @click="openFile" class="btn btn-warning">Choose File
                                            <b-icon scale="0.8" icon="cloud-arrow-up"></b-icon>
                                        </div>
                                        <b-form-file @change="showFileName" style="visibility:hidden" id="fileImage"
                                            class="mt-3" plain></b-form-file><span>{{filename}}</span>
                                    </div>
                                </div>
                            </b-row>
                            <p id="guest-pref" class="mb-4 mt-4">Guest Preference</p>
                            <b-row class="mt-4">
                                <b-form-group class="col-md-6 mb-4" label-for="age_limit">
                                    <b-input-group class="">
                                        <b-form-input type="number" min="1" v-model="listing.age_limit"
                                            placeholder="Age Limit (not under)"></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group class="col-md-6 mb-4" label-for="age_limit">
                                    <b-input-group class="">
                                        <b-form-input type="text" v-model="listing.item_contributions"
                                            placeholder="Item contributions"></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group class="col-md-6 mb-4" label-for="guest_limit">
                                    <b-input-group class="">
                                        <b-form-input type="number" required min="0" v-model="listing.guest_limit"
                                            placeholder="Guest Limit (No. of total guests)"></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group class="col-md-6 mb-4" label-for="guest_gender">
                                    <b-form-select required v-model="listing.guest_gender" :options="genders">
                                    </b-form-select>
                                </b-form-group>
                                <b-form-group class="col-md-6 mb-4" label-for="input-1">
                                    <b-form-select required v-model="listing.guest_category" :options="statuses">
                                    </b-form-select>
                                </b-form-group>
                                <b-form-group class="col-md-6 mb-4" label-for="guest_nationality_id">
                                    <select required class="mb-3 custom-select" v-model="listing.guest_nationality_id">
                                        <option value="" selected disabled>Please select nationality</option>
                                        <option v-for="(country, index) in countries" :key="index"
                                            :value="country.country_id">
                                            {{ country.name }}
                                        </option>
                                    </select>
                                </b-form-group>

                            </b-row>
                            <p id="recipe-pref" class="mb-4 mt-4">Recipe Preference</p>
                            <b-row class="mt-4">
                                <b-form-checkbox v-model="attach_recipe" switch inline class="col-md-12 my-2 mb-3">
                                    Do you want to attach a recipe to this event?
                                </b-form-checkbox>

                                <b-form-group v-if="attach_recipe" class="col-md-12 mb-4" label-for="recipe">
                                    <select required class="mb-3 custom-select" v-model="listing.recipe_id">
                                        <option value="" selected disabled>Select a recipe</option>
                                        <option v-for="(recipe, index) in userRecipes" :key="index"
                                            :value="recipe.food_id">
                                            {{ recipe.name }}
                                        </option>
                                    </select>
                                </b-form-group>
                            </b-row>
                            <p id="finish-up">Finishing up </p>
                            <b-row class="mt-4">
                                <b-form-group class=" col-md-12 mb-3" label-for="input-1">
                                    <button class="float-right btn btn-warning">{{btnText}}
                                        <font-awesome-icon :icon="['fas', 'arrow-right']" />
                                    </button>
                                </b-form-group>

                            </b-row>
                        </div>
                    </b-col>
                </b-row>
            </div>

        </b-container>
        <Footer />
    </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Footer from "@/components/Footer.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import ListingSidebar from "@/components/ListingSidebar.vue";
import Activation from "@/components/Activation.vue";
import axios from "axios";
import VueGoogleAutocomplete from 'vue-google-autocomplete';

import {
    getBaseUrl
} from "../../../utils/common";
const base_url = getBaseUrl();
export default {
    name: 'edit-listings',
    components: {
        Header,
        BodyLinks,
        BlackHeaderCenter,
        BlackHeaderMobile,
        ListingSidebar,
        Activation,
        DatePicker,
        VueGoogleAutocomplete,
        Footer
    },
    data: function () {
        return {
            headerText: "Experience The world",
            subText: "Create a listing, and host experiences both online and offline",
            fadedText: "Hosts",
            active: false,
            selected: 0,
            attach_recipe:false,
            btnText: 'Update Listing',
            customToolbar: [
                ["bold", "italic", "underline"],
                [{
                    list: "ordered"
                }, {
                    list: "bullet"
                }]
            ],
            filename: '',
            listing: {
                name: '',
                region: null,
                attendance_mode: null,
                event_sub_type_id: null,
                fee_status: null,
                currency: null,
                amount: '',
                start_day: '',
                end_day: '',
                start_time: '',
                end_time: '',
                address: '',
                age_limit: '',
                guest_limit: '',
                guest_gender: null,
                guest_category: null,
                guest_nationality_id: null,
                item_contributions: '',
                event_type_id: ''

            },
            genders: [{
                    value: null,
                    text: 'Select member gender'
                },
                {
                    value: 'male',
                    text: 'Male'
                },
                {
                    value: 'female',
                    text: 'Female'
                },
                {
                    value: 'other',
                    text: 'Other'
                },
                {
                    value: 'any',
                    text: 'Any'
                },

            ],
            regions: [{
                    value: null,
                    text: 'Select region'
                },
                {
                    value: 'africa',
                    text: 'Africa'
                },
                {
                    value: 'asia',
                    text: 'Asia'
                },
                {
                    value: 'caribbean',
                    text: 'Caribbean'
                },
                {
                    value: 'camerica',
                    text: 'Central America'
                },
                {
                    value: 'namerica',
                    text: 'North America'
                },
                {
                    value: 'samerica',
                    text: 'South America'
                },
                {
                    value: 'europe',
                    text: 'Europe'
                },
                {
                    value: 'mideast',
                    text: 'Middle East'
                },
                {
                    value: 'oceania',
                    text: 'Oceania'
                },

            ],
            statuses: [{
                    value: null,
                    text: 'Select member status'
                },
                {
                    value: 'family',
                    text: 'Family'
                },
                {
                    value: 'couple',
                    text: 'Couple'
                },
                {
                    value: 'singles',
                    text: 'Singles'
                },
                {
                    value: 'any',
                    text: 'Any'
                },

            ],
            fees: [{

                    value: null,
                    text: 'Fee status'
                }, {

                    value: "Free",
                    text: "Free"
                },
                {
                    value: 'Paid',
                    text: "Paid"
                },

            ],
            currencies: [{
                value: null,
                text: 'Select Currency'
            }, {

                value: "USD",
                text: "USD"
            }, ],
            options: [{
                    value: null,
                    text: 'Please select an option'
                },
                {
                    value: 'food',
                    text: 'Food'
                },
                {
                    value: 'art',
                    text: 'Art'
                },
                {
                    value: 'fashion',
                    text: 'Fashion'
                },

            ],
            attendances: [{
                    value: null,
                    text: 'Select Attendance mode'
                },
                {
                    value: "physical",
                    text: 'In Person'
                },
                {
                    value: "online",
                    text: 'Online'
                },
            ],
            profileImage: '',
            isPersonalProfile: true,
            isBusinessProfile: false,
            isPublicProfile: false,
            listingTypeSelected: null,
            categories: [],
            countries: [],
            subCategories: [],
            no_per_page:10
        }
    },
    computed: {
        currentUser: function () {
            return this.$store.getters.currentUser;
        }
    },
    mounted() {
        this.getCategories();
        this.getCountries();
        this.getListingDetails();
    },
    methods: {
        openFile() {
            document.getElementById('fileImage').click()
        },
        showFileName() {
            const file = document.getElementById('fileImage').files[0];
            this.filename = file.name
        },
        selectedOption(option) {
            if (this.value) {
                return option.name === this.value.name;
            }
            return false;
        },
        categoryChange() {
            this.getsubCategories(this.listing.event_type_id)
        },
        isSelected(i) {
            return i === this.selected
        },
        showPersonalProfile() {
            this.isPersonalProfile = true;
            this.isBusinessProfile = false
            this.isPublicProfile = false
        },
        showBusinessProfile() {
            this.isPersonalProfile = false;
            this.isBusinessProfile = true
            this.isPublicProfile = false
        },
        showPublicProfile() {
            this.isPersonalProfile = false;
            this.isBusinessProfile = false
            this.isPublicProfile = true
        },
        openMenu() {
            var slide = document.getElementById('slidmenu')
            if (slide.style.marginLeft === '-347%') {
                slide.style.marginLeft = '-24px'

            } else {
                slide.style.marginLeft = '-347%'
            }
        },
        hideSidemenu() {
            var slide = document.getElementById('slidmenu')
            slide.style.marginLeft = '-347%'
        },
        async getCountries() {
            try {
                const resp = await axios.get(`${base_url}/api/v2/countries`)
                const country = {
                    country_id: null,
                    name: "Any",
                    namecode: "Any",
                    phonecode: "A"
                };
                const countries = [{
                    ...country
                }, ...resp.data.data];
                this.countries = countries;
            } catch (error) {
                console.warn(error);
            }
        },
        async getCategories() {
            try {
                const resp = await axios.get(`${base_url}/api/v2/evtypes`)
                this.categories = resp.data
            } catch (error) {
                console.warn(error);
            }
        },
        async getsubCategories(evtype_id) {
            try {
                const resp = await axios.get(`${base_url}/api/v2/evtypes?evtype_id=${evtype_id}`)
                this.subCategories = resp.data
            } catch (error) {
                console.warn(error);
            }
        },
        async getListingDetails() {
            const id = this.$route.params.id;
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/events/${id}`,
                    method: "GET",
                })
                this.listing = Object.assign({}, resp.data.data);
                this.listing.region = this.listing.region.toLowerCase()
                this.getsubCategories(this.listing.event_type_id)

            } catch (error) {
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        async updateListing() {
            const eventid = this.$route.params.id;
            this.btnText = 'Updating...'
            const image = document.getElementById("fileImage").files[0]
            let data = new FormData();
            if (image) {
                data.append("images", document.getElementById("fileImage").files[0]);
            }
            data.append('name', this.listing.name)
            data.append('region', this.listing.region)
            data.append('attendance_mode', this.listing.attendance_mode)
            data.append('description', this.listing.description)
            data.append('address', this.listing.address)
            data.append('start_day', this.listing.start_day)
            data.append('end_day', this.listing.end_day)
            data.append('start_time', this.listing.start_time)
            data.append('end_time', this.listing.end_time)
            data.append('guest_gender', this.listing.guest_gender)
            data.append('age_limit', this.listing.age_limit)
            data.append('guest_limit', this.listing.guest_limit)
            data.append('guest_nationality_id', this.listing.guest_nationality_id)
            data.append('guest_category', this.listing.guest_category)
            data.append('event_sub_type_id', this.listing.event_sub_type_id)
            data.append('item_contributions', this.listing.item_contributions)
            data.append('fee_status', this.listing.fee_status)
            if (this.listing.currency) {
                data.append('currency', this.listing.currency)
            }
            if (this.listing.amount) {
                data.append('amount', this.listing.amount)
            }
            if (this.attach_recipe) {
                data.append('recipe_id', this.event.recipe_id)
            }
            try {
                await axios({
                    url: `${base_url}/api/v2/events/${eventid}?_method=PUT`,
                    data: data,
                    method: "POST",
                })
                this.btnText = 'Update Listing'
                this.$router.push("/listings/created");
            } catch (error) {
                this.btnText = 'Update Listing'
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        async getRecepies(page = 1) {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/foodlistings?page=${page}`,
                    params: {
                        no_per_page: this.no_per_page,
                        cook_id: this.currentUser.user_id
                    },
                    method: "GET",
                })
                this.userRecipes = resp.data.data
            } catch (error) {
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },

    }

}
</script>

<style lang="scss" scoped>
.file-container {
    padding: 20px 30px 30px 20px;
    background: #fff;
}

.custom-select {
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
    border-radius: 8px;
    padding: 20px 16px;
    border: none;
    height: 59px;
    width: 100%;
}

.input-group {
    border-radius: 8px !important;
    height: 58px;
    margin: 0 !important
}

.form-control {
    border-radius: 0 8px 8px 0 !important;
    height: calc(2em + 0.75rem + 15px) !important;

}

.textbox {
    padding: 20px;
    border-radius: 8px !important;
}

.shadow {
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.input-group-text {
    border-radius: 8px 0 0 8px !important;
    padding: 1.2rem 2px 1.2rem 1rem !important
}

.btn-culture {
    padding: 10px 60px !important;
}

.custom-select:focus {
    outline: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.bi-search {
    margin-right: 1rem;
}

.custom-select.caret {
    padding-right: 100px;
}

.custom-control {
    margin: 20px auto
}

.btn-box {
    margin: 14px 0
}

.head-box {
    margin: 35px auto auto;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);
    border-radius: 5px;
    padding: 10px;
    background-color: #fff;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        margin: 0;
    }
}

.inner-header-box {
    padding: 20px;
    border-radius: 4px;
    cursor: pointer;
}

.inner-header-box:hover {
    background: #000;
    color: #fff;
    border-radius: 4px;
    transition: ease-in 0.3s;

}

.inner-header-box.active {
    background: #000;
    color: #fff;
    border-radius: 4px;
}

.inner-header-box:hover .b-icon.bi,
.inner-header-box.active .b-icon.bi {
    color: rgba(247, 177, 49, 1)
}

textarea.form-control {
    height: auto !important;
}

.form-control[readonly] {
    background-color: #fff !important;
}

.profile-card {
    margin: 35px auto auto;
    padding: 16px 16px 16px 16px;
    background: #FFFFFF;
    box-shadow: 2px 6px 19px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
}

.slide-menu {
    position: absolute;
    z-index: 99;
    background: #fff;
    margin-left: -347%;
    width: 328%;
    top: -2px;
    padding-left: 16px;
    transition: all 0.5s ease-in-out;
}
</style>
